import { useEffect, useState } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    Typography,
    Popover,
    MenuList,
} from '@material-ui/core';
import {} from './../handler/ShareStatusKnowledgeHandler';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '@material-ui/core';
import './ListItemTagField.css';
import { bulkActionHelpdeskTaskIdAtom, bulkActionKnowledgeTaskIdAtom } from '@/state/atom/ticketKnowledgeAtom';
import { cloneDeep } from 'lodash';
import { handleBulkUpdateTicketAPI, handleMsgPendingWhenBulkActionInProcessing } from '../handler/ListTicketKnowledgeHandler';
import { useSnackbar } from 'notistack';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { translateByDisplayType, getDrilldownTagItemDisplayType } from '@/common/utils/DrilldownDisplayUtils';
import RenderTagItemSingleChoice from './RenderTagItemSingleChoice';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import PropTypes from 'prop-types';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

ListItemSingleChoice.propTypes = {
    selectedTagField: PropTypes.any,

};

function ListItemSingleChoice(props) {
    // Subscribe to translation updates so displayed tag item names re-render on language change
    useTranslationSubscription();
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const userDetail = useRecoilValue(userAtom);

    const [openShareStatusPopover, setOpenShareStatusPopover] = useState('');
    const idPopoverShareStatus = openShareStatusPopover ? 'simple-popover' : undefined;
    const [shareStatusPopover, setShareStatusPopover] = useState(false);
    const [listItem, setListItem] = useState([]);
    const setKnowledgeTaskId = useSetRecoilState(bulkActionKnowledgeTaskIdAtom);
    const setHelpDeskTaskId = useSetRecoilState(bulkActionHelpdeskTaskIdAtom);
    const { enqueueSnackbar } = useSnackbar();
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const [isDisable, setIsDisable] = useState(false);
    const [isOnChange,setIsOnChange] = useState(false);
    const [selectedId, setSelectedId] = useState('');
    const [maxItemShow, setMaxItemShow] = useState(Constant.BULK_ACTION_DEFAULT_VALUE.TAG_ITEM_DISPLAY);
    const corporationDetail = useRecoilValue(corporationAtom);

    useEffect(() => {
        let listItemOfTagField = [];
        setSelectedId('')
        props.listTagItem?.forEach(itemDetail => {
            if (itemDetail?.structure?.isShowItemInTicket) {
                let itemInfo = {
                    id: itemDetail.id,
                    name: itemDetail.name,
                    no: itemDetail?.structure?.no,
                    status: 'uncheck',
                    isTagMaster: itemDetail?.isTagMaster
                };

                listItemOfTagField.push(itemInfo);
            }
        });

        listItemOfTagField = Utils?.sortDrillDownByNo(listItemOfTagField);
        if (
            ![
                Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
                Constant.SYSTEM_FIELD.AI_TELEPHONE_REALTIME_MODEL,
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER
            ].includes(props?.selectedTagField?.sysField)
        ) {
            const SYSTEM_FIELD_NOT_HAS_UNCHECK = [
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FOLLOW_UP_STATUS,
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.REVIEW_STATUS
            ]
            if (!SYSTEM_FIELD_NOT_HAS_UNCHECK.includes(props?.selectedTagField?.sysField)) {
                listItemOfTagField.unshift({
                    id: 'single_choice_uncheck_all_item',
                    name: tr('選択してください'),
                    no: listItemOfTagField.length,
                    status: 'uncheck'
                });
            }
        } else if (props?.selectedTagField?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_REALTIME_MODEL) {
            // Mark unsupported realtime models as hidden but keep in list for proper uncheck handling
            listItemOfTagField = listItemOfTagField.map(item => {
                if (TelephoneConstant.UNSUPPORTED_REALTIME_MODELS.includes(item.name)) {
                    return { ...item, status: 'uncheck', isHidden: true };
                }
                return item;
            });
        } else {
            let listChatGPTModel = Utils.convertJSONDataToObject(corporationDetail.corporationSetting)?.listChatGptModel || [];
            const supportedModels = new Set(
                listChatGPTModel.filter(model => model.status === Constant.CHAT_GPT_MODEL_STATUS.SUPPORT).map(model => model.id)
            );

            listItemOfTagField = listItemOfTagField.filter(item =>
                [Constant.NO_PREFERENCE, Constant.NO_REFERENCE].includes(item.name) || supportedModels.has(item?.name?.toLowerCase())
            );
        }
        setListItem(listItemOfTagField);
    }, [props.drillDownData, props.listTagItem, props.totalTickets]);

    useEffect(() => {
        if (props?.selectedTagField?.required) {
            let listItemIsCheck = listItem?.filter(item => {
                if (item.status === 'checked' && item.id !== 'single_choice_uncheck_all_item') {
                    return true;
                } else {
                    return false;
                }
            });

            if (Utils.isEmptyArray(listItemIsCheck)) {
                setIsDisable(true);
            } else {
                setIsDisable(false);
            }
        } else {
            setIsDisable(false);
        }
    }, [listItem]);

    const handleOnChange = item => {
        let itemClone = cloneDeep(item);
        setSelectedId(item.id)
        itemClone.status = 'checked';
        let currentSelectItem = listItem?.find(itemDetail => itemDetail.status === 'checked');
        if(!Utils.isEmptyObject(currentSelectItem)){
            if(currentSelectItem.id === itemClone.id) return
        }
        let indexOfActionItem = listItem?.findIndex(itemDetail => itemDetail.id === item.id);
        if (indexOfActionItem >= 0) {
            let listItemClone = cloneDeep(listItem);
            listItemClone = listItemClone?.map(itemMap => {
                itemMap.status = 'uncheck';
                return itemMap
            });
            listItemClone[indexOfActionItem] = itemClone;

            const sysFieldNotHasNoPreference = [Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL, Constant.SYSTEM_FIELD.AI_TELEPHONE_REALTIME_MODEL];
            const isFieldNotHasNoPreference = sysFieldNotHasNoPreference.includes(props?.selectedTagField?.sysField);
            const isRequired = props?.selectedTagField?.required;
            setIsOnChange(isFieldNotHasNoPreference || !(isRequired && indexOfActionItem === 0));
            setListItem([...listItemClone]);
        }
    };

    const handleSubmitEditTagFields = async () => {
        setMaxItemShow(Constant.BULK_ACTION_DEFAULT_VALUE.TAG_ITEM_DISPLAY);
        if (props.totalTickets > Constant.LIMIT_TICKET_UPDATE_MULTI) {
            props.setIsShowEditTagField(false);
            props.setIsShowDialogNotiLimit(true)
            return;
        }

        let listItemObject = listItem
            ?.filter(item => item.id !== 'single_choice_uncheck_all_item')
            .map(item => {
                let itemObject = { itemId: item.id };
                if (item.status === 'checked') {
                    itemObject.isCheckAll = true;
                }
                if (item.status === 'uncheck') {
                    itemObject.uncheckAll = true;
                }

                return itemObject;
            });

        let params = {
            searchCondition: JSON.stringify({
                listItem: listItemObject,
                tagFieldId: props?.selectedTagField?.id,
                isProjectManager: isProjectManager,
                ...props.currentSearchParams,
                userAffiliationOrganization: userDetail?.affiliationOrganization || props?.currentSearchParams?.corporationId,
                projectInuse: projectInuseDetail?.id,
                formId: props.selectedFormId,
                userId: userDetail?.id,
                corporationInuse: userDetail?.affiliationOrganization
            }),
            action: props?.action
        };
        let setTaskId =  props?.action === Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD ? setHelpDeskTaskId : setKnowledgeTaskId
        props.setIsShowEditTagField(false);
        handleBulkUpdateTicketAPI(
            { params: params },
            null, //setIsOpenDialogConfirm
            setTaskId,
            false,
            enqueueSnackbar,
            props.setIsOpenAlertDialog
        );
        props.setMsgInProcessingIcon(
            handleMsgPendingWhenBulkActionInProcessing(props?.action)
        );
    };

    useEffect(()=>{
        setIsOnChange(false)
    },[props?.selectedTagField])

    const handleOnScrollTagItem = event => {
        let elementWhenScroll = event.target;
        if (
            elementWhenScroll.offsetHeight + elementWhenScroll.scrollTop >=
            elementWhenScroll.scrollHeight
        ) {
            setMaxItemShow(prev => parseInt(prev + 15));
        }
    };

    const renderMenuItem = () => {
        let itemList = [];
        for (let i = 0; i < listItem.length; i++) {
            if (i >= maxItemShow) continue;
            let item = listItem[i];
            if (item?.isHidden) continue;

            // 'single_choice_uncheck_all_item' is already translated via tr() when built above; skip re-translation here.
            const displayValue = item?.id === 'single_choice_uncheck_all_item'
                ? item?.name
                : translateByDisplayType(item?.name, getDrilldownTagItemDisplayType({
                    itemId: item?.id,
                    sysField: props?.selectedTagField?.sysField
                }));

            itemList.push(
                <RenderTagItemSingleChoice
                    key={item?.id}
                    id={item?.id}
                    item={item}
                    value={item?.id}
                    onClick={handleOnChange}
                    className={item?.id === selectedId ? 'menu-single-item-checked' : 'menu-single-item'}
                    name={item?.name}
                    isTagMaster={item?.isTagMaster}
                >
                    <OverFlowTooltipWithTabsMui value={displayValue}/>
                </RenderTagItemSingleChoice>
            )
        }

        return (
            <MenuList id="composition-menu" aria-labelledby="composition-button">
                {itemList}
            </MenuList>
        );
    };

    const handleClickShowShareStatus = event => {
        setOpenShareStatusPopover(true);
        props.setIsShowListItemOfTagField(true);
        setShareStatusPopover(event.currentTarget);
    };

    const handleClosePopoverShareStatus = async () => {
        setShareStatusPopover(null);
        setOpenShareStatusPopover(false);
        props.setIsShowListItemOfTagField(false);
    };

    return (
        <div className="">
            <Typography
                className=""
                aria-describedby={idPopoverShareStatus}
                variant="contained"
                onClick={e => handleClickShowShareStatus(e)}
            >
                {' '}
                <img src="/assets/image/edit-setting-public-url.svg" alt="icon-edit-range" />
            </Typography>
            <Popover
                className="share-status-popover"
                id={idPopoverShareStatus}
                key={`popover-share-status-all`}
                open={openShareStatusPopover}
                anchorEl={shareStatusPopover}
                onClose={e => {
                    handleClosePopoverShareStatus();
                    setMaxItemShow(Constant.BULK_ACTION_DEFAULT_VALUE.TAG_ITEM_DISPLAY);
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                PaperProps={{
                    style: {
                        marginTop: '12px',
                        marginLeft: '7px',
                        borderRadius: '8px',
                        minWidth: '300px'
                    }
                }}
            >
                <div>
                    <div
                        className="listView knowledge-share-public-status-list"
                        id={`share_status_id_all`}
                    >
                        <div className="list-permission-status list-item-selected-tag-field" onScroll={e => handleOnScrollTagItem(e)}>
                            {renderMenuItem()}
                        </div>
                        <div className="share-status-popover-additional">
                            <Button
                                className="btn-send btn-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={e => handleSubmitEditTagFields()}
                                disabled={isDisable || !isOnChange}
                            >
                                {tr('適用')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Popover>
        </div>
    );
}

export default ListItemSingleChoice;
